/**
 * Simpele, persistente wachtrij (in localStorage) voor frontend-logmeldingen die niet direct
 * naar de backend verstuurd konden worden (bv. omdat de client offline was). Bij het herstellen
 * van de verbinding kan de wachtrij alsnog geleegd worden, zodat er geen logmeldingen verloren gaan.
 */
const STORAGE_KEY = 'bam.pendingFrontendLogs';
const MAX_QUEUE_LENGTH = 5;

export type PendingLogEntry = {
  id: string;
  endpoint: string;
  body: Record<string, unknown>;
  timestamp: string;
};

function readQueue(): PendingLogEntry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as PendingLogEntry[]) : [];
  } catch {
    return [];
  }
}

function writeQueue(entries: PendingLogEntry[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(-MAX_QUEUE_LENGTH)));
  } catch {
    console.log('localStorage niet beschikbaar of vol, negeer (best effort)');
  }
}

export function queuePendingLog(endpoint: string, body: Record<string, unknown>): void {
  const entries = readQueue();

  // niet loggen als hetzelfde bericht eerder is gelogd
  const latest = entries[entries.length - 1];
  const isEerderGelogd = latest?.endpoint === endpoint && JSON.stringify(latest.body) === JSON.stringify(body);
  if (isEerderGelogd) {
    return;
  }

  entries.push({ id: crypto.randomUUID(), endpoint, body, timestamp: new Date().toISOString() });
  writeQueue(entries);
}

export function getPendingLogs(): PendingLogEntry[] {
  return readQueue();
}

export function setPendingLogs(entries: PendingLogEntry[]): void {
  writeQueue(entries);
}
